import { forwardRef } from 'react';
import PropTypes from 'prop-types';
// import customPropTypes from 'lib/customPropTypes';
// import styled from 'styled-components';
import globals from 'styles/globals';

import DeprecatedButton, { ButtonPropTypes } from '../index';

const DeprecatedPrimaryButton = ({ forwardedRef, baseStyle, hoverStyle, disabledStyle, ...buttonProps }) => {
  const primaryBaseStyle = {
    fontColor: globals.colors.white,
    bgColor: globals.colors.primary,
    borderColor: globals.colors.primary,
    ...baseStyle,
  };

  const primaryHoverStyle = {
    bgColor: globals.colors.primaryHover,
    borderColor: globals.colors.primaryHover,
    ...hoverStyle,
  };

  const primaryDisabledStyle = {
    bgColor: globals.colors.primaryDisabled,
    borderColor: globals.colors.primaryDisabled,
    ...disabledStyle,
  };

  const computedProps = {
    baseStyle: primaryBaseStyle,
    hoverStyle: primaryHoverStyle,
    disabledStyle: primaryDisabledStyle,
    spinnerInnerColor: globals.colors.fontLight,
    spinnerOuterColor: globals.colors.mediumGrey,
    ...buttonProps,
  };

  return <DeprecatedButton ref={forwardedRef} {...computedProps} />;
};

DeprecatedPrimaryButton.propTypes = {
  baseStyle: ButtonPropTypes.style,
  hoverStyle: ButtonPropTypes.style,
  disabledStyle: ButtonPropTypes.style,
  // eslint-disable-next-line react/forbid-prop-types
  forwardedRef: PropTypes.any,
};

DeprecatedPrimaryButton.defaultProps = {
  baseStyle: {},
  hoverStyle: {},
  disabledStyle: {},
  forwardedRef: undefined,
};

export default forwardRef((props, ref) => <DeprecatedPrimaryButton {...props} forwardedRef={ref} />);
